import React from "react";
import {
  NumberInput,
  List,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  DateField,
  FunctionField,
  EditButton,Button,Link,
  Edit,
  SimpleForm,
  DisabledInput
} from "react-admin";
import moment from "moment";
import styled from "styled-components";
import RentalBookingForm from "../components/rentalBookingForm";
import { isNil, path, isEmpty, head, prop } from "ramda";
import Add from "@material-ui/icons/Add";
import { getPermissionRole } from "../util";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);
const rentalDays = rental => {
  let days = moment(rental.date_2).diff(moment(rental.date_1), 'days')

  if (rental.type === 2) {
    if (rental.time_1 === '10:00:00' && rental.time_2 === '18:00:00') {
      days += 1
    } else if (rental.time_1 === '18:00:00' && rental.time_2 === '10:00:00') {
      days -= 1
    }
  }
  return days
}
const StyledDiv = styled.div((props) => ({
  flexDirection: "column",
  alignItems: props.align ? props.align : "center",
  justifyContent: props.justify ? props.justify : "center",
  backgroundColor: props.color,
  paddingTop: props.padding ? props.padding : "0px",
  paddingBottom: props.padding ? props.padding : "0px",
  minHeight: "40px",
  display: "flex",
  minWidth: "100px",
}));

const validateForm = values => {
  const errors = {};
  if (!values.km_1) {
    errors.km_1 = ["Km Begin is required"];
  }
  if (!values.km_2) {
    errors.km_2 = ["Km End is required"];
  }

  if (values.km_1 && values.km_2) {
    if (values.km_1 > values.km_2) {
      errors.km_2 = ["Km End must be greather than Km Start"];
    }
  }
  return errors;
};

export const UnenteredKmRentalsEdit = props => {
  const p = props
  const redirect = p.location.state
  let link = '/unentered_km_rentals'
  if (redirect != null) {
    link = `/${redirect.miga}`
  } 
  return (
  <Edit title="Add Extra Kms" {...props}>
    <SimpleForm validate={validateForm} redirect={link}>
      <DisabledInput label="Id" source="id" />
      <FunctionField label="Rental Days" render={rentalDays} />
      <DateField label="Date Begin" source="date_1" />
      <DateField label="Date End" source="date_2" />
      <ReferenceField
        label="Customer"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <FunctionField
          render={booking => {
            return `${booking.r_first_name} ${booking.r_last_name}`;
          }}
        />
      </ReferenceField>
      <ReferenceField
        label="Vehicle"
        source="vehicle[0].id"
        reference="vehicles"
        linkType={true}
      >
        <FunctionField
          render={vehicle => {
            return `${vehicle.licence_plate} ${vehicle.renting ? "®" : ""}`;
          }}
        />
      </ReferenceField>
      <NumberInput label="Km begin" source="km_1" />
      <NumberInput label="Km End" source="km_2" />
    </SimpleForm>
  </Edit>
)};

const Booking = record => {
  if (record.render.booking_id == 0) {
    return (
      <div>
        N/A
      </div>
    )
  }
  else{
    return (
      <div>
          <FunctionField
            addLabel={false}
            render={rental => {
              return <RentalBookingForm bookingId={record.render.booking_id } />;
            }}
          />
      </div>
    )
  }
};
export const UnenteredKmRentalsList = props => (
  <List {...props} pagination={<ListPagination />} bulkActionButtons={false}>
    <Datagrid>
      <FunctionField
        label="Bike"
        render={rental => {
          if(rental.vehicle[0] == undefined){
            return `${rental.tipo} - ${rental.vehicle.model.model_name}, ${rental.vehicle.licence_plate} ${rental.vehicle.renting ? "®" : ""}, ${rental.vehicle.vehicle_color == null ? 'N/A': rental.vehicle.vehicle_color}, ${rental.vehicle.vehicle_mileage}`;
          }
          else{
            return `${rental.tipo} - ${rental.vehicle[0].model.model_name}, ${rental.vehicle[0].licence_plate} ${rental.vehicle[0].renting ? "®" : ""}, ${rental.vehicle[0].vehicle_color}, ${rental.vehicle[0].vehicle_mileage}`;
          }
        }}
      />
      <DateField label="Pick-up date" source="date_1" />
      <DateField label="Drop-off date" source="date_2" />

      <FunctionField
        label="Rental Type"
        render={rental => {
          return rental.type === 2 ? "Rental" : "Tour";
        }}
      />

      <FunctionField label="Rental Days" render={rentalDays} />

      <ReferenceField
        label="Location"
        source="location_id_2"
        reference="locations"
        linkType={false}
      >
        <FunctionField
          label="location"
          addLabel={false}
          render={(locations) => {
            return (
              <StyledDiv color={locations.color}>
                {locations.location_name}
              </StyledDiv>
            );
          }}
        />
        {/* <TextField source="location_name" /> */}
      </ReferenceField>
      <ReferenceField
        label="Customer"
        source="booking_id"
        reference="bookings"
        linkType={false}
      >
        <FunctionField
          render={booking => {
            if (booking.r_first_name != undefined) {
              return `${booking.r_first_name} ${booking.r_last_name}`;
            }
            else{
              return `N/A`
            }
          }}
        />
      </ReferenceField>
      <FunctionField
        label="Booking"
        render={rental => {
          return <Booking render={rental}/>
        }}
      />
      <FunctionField
        label="Days Late"
        render={rental => {
          return moment().diff(moment(rental.date_2), "days");
        }}
      />

      <Buttons />
    </Datagrid>
  </List>
);


const Buttons = ({ record = {} }) => {
  if ([1, 2, 3, 4, 5, 6, 7, 9].includes(getPermissionRole())){
    if (record.tipo == 'G-BIKE') {
      return (
        <div>
          <Button
            component={Link}
            style={{ width: "100px" }}
            to={{
              pathname: `/unentered_km_tour_bikes/${record.id}`
            }}
            label="Enter"
          >
            <Add />
          </Button>
        </div>
      );
    }
    else if (record.tipo == 'VANS') {
      return (
        <div>
          <Button
            component={Link}
            style={{ width: "100px" }}
            to={{
              pathname: `/unentered_km_tour_vans/${record.id}`
            }}
            label="Enter"
          >
            <Add />
          </Button>
        </div>
      );
    }
    else{
      return (
        <div>
          <Button
            component={Link}
            style={{ width: "100px" }}
            to={{
              pathname: `/unentered_km_rentals/${record.id}`
            }}
            label="Enter"
          >
            <Add />
          </Button>
        </div>
      );
    }    
  } else {
    return null;
  }

};



// WEBPACK FOOTER //
// ./src/resources/unenteredKmRentals.js